import CategoryCheckbox from './CategoryCheckbox';

export default CategoryCheckbox;
